import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface GlobalSearchContextValue {
  isOpen: boolean;
  openSearch: () => void;
  closeSearch: () => void;
  /** /luagate の外枠が自分の探す窓を持つとき、マウントの間だけ呼ぶ (返す関数で手放す)。持つ間、root の古い窓は開かない */
  claimSearchWindow: () => () => void;
  windowClaimed: boolean;
}

const GlobalSearchContext = createContext<GlobalSearchContextValue | null>(null);

export function GlobalSearchProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openSearch = () => setIsOpen(true);
  const closeSearch = () => setIsOpen(false);
  const [claims, setClaims] = useState(0);
  const claimSearchWindow = useCallback(() => {
    setClaims((n) => n + 1);
    return () => setClaims((n) => n - 1);
  }, []);

  return (
    <GlobalSearchContext.Provider value={{ isOpen, openSearch, closeSearch, claimSearchWindow, windowClaimed: claims > 0 }}>
      {children}
    </GlobalSearchContext.Provider>
  );
}

export function useGlobalSearch() {
  const context = useContext(GlobalSearchContext);
  if (!context) {
    throw new Error('useGlobalSearch must be used within a GlobalSearchProvider');
  }
  return context;
}
